import request from '@/utils/request' //引入封装好的 axios 请求



export function selectList(data = {}) { //查询白名单列表
  return request({ //使用封装好的 axios 进行网络请求
    url: '/api/v1/loginWhitelist/selectList',
    method: 'post',
    data: data
  })
}
export function addWhiteList(data = {}) { //添加白名单
  return request({ //使用封装好的 axios 进行网络请求
    url: '/api/v1/loginWhitelist/add',
    method: 'post',
    data: data
  })
}

export function modWhiteList(data = {}) { //修改白名单
  return request({ //使用封装好的 axios 进行网络请求
    url: '/api/v1/loginWhitelist/mod',
    method: 'post',
    data: data
  })
}

export function delWhiteList(data = {}) { //删除白名单
  return request({ //使用封装好的 axios 进行网络请求
    url: '/api/v1/loginWhitelist/del',
    method: 'post',
    data: data
  })
}